import { translateInline } from '@/globals/translate/translateInline';

export const contentID = translateInline({
	en: 'content',
	nl: 'inhoud',
});
